// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__Ff6KR","previous":"Pagination_previous__3F9V2","next":"Pagination_next__2jcHh"};